import { Component, OnInit, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import {
  format, differenceInCalendarDays, startOfMonth, endOfMonth, startOfISOWeek, endOfISOWeek,
  startOfYear, endOfYear, subDays, startOfDay, endOfDay, getISOWeek, getHours, getMinutes,
  getSeconds, getISOWeekYear, startOfQuarter, endOfQuarter
} from 'date-fns';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { DisabledTimeFn } from 'ng-zorro-antd/date-picker/standard-types';
import { disabledStart, disabledEnd } from '../config/constant' 
import { queryCondition} from './microenv-search-interface'
type quater = 1 | 2 | 3 | 4


@Component({
  selector: 'bcac-microenv-search',
  templateUrl: './microenv-search.component.html',
  styleUrls: ['./microenv-search.component.scss']
})
export class MicroenvSearchComponent implements OnInit {
  isCollapsed = false;
  _isShowTime: boolean = true
  _conditionLists = []
  _conditionListsLength: number = this._conditionLists.length - 1
  _selectedQuater = 1
  _selectedQuaterStart = 1
  _selectedQuaterEnd = 4
  _isShowTimeTypeDropdown: boolean = true
  _isShowCollapsed: boolean = false
  _isShowOuterCheckAll: boolean = true
  quaterLists = [
    { label: '一季度', value: 1 },
    { label: '二季度', value: 2 },
    { label: '三季度', value: 3 },
    { label: '四季度', value: 4 },
  ]
  constructor(
    private message: NzMessageService,
    private datepipe: DatePipe,
  ) { }

  @Input() set bcacIsShowTimeTypeDrop(show: boolean) {
    this._isShowTimeTypeDropdown = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }

  @Input() set bcacIsShowCollapsed(show: boolean) {
    this._isShowCollapsed = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }

  @Input() set bcacIsShowOuterCheckAll(show: boolean) {
    this._isShowOuterCheckAll = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }

  @Input() set bcacConditionLists(data: queryCondition[]) {
    if (data && data.length) {
      this._conditionLists = data.map((item) => {
        let totaldNum = item.queryItemlists.length
        let selectedNum = this.countNum(item.queryItemlists)
        return {
          ...item,
          toltalNumber: totaldNum,
          selectedNumber: selectedNum,
          isAllChecked: totaldNum === selectedNum ? true : false,
          indeterminate: selectedNum > 0 && selectedNum < totaldNum ? true : false
        }
      })
      /* if (this._conditionLists.length) {
        for (const item of data) {
          for (let existitem of this._conditionLists) {
            if (JSON.stringify(item) != JSON.stringify(existitem)) {
              let totaldNum = item.queryItemlists.length
              let selectedNum = this.countNum(item.queryItemlists)
              existitem = {
                queryItemName: item.queryItemName,
                queryItemlists: item.queryItemlists,
                isopen: item.isopen,
                isNewSection: item.isNewSection,
                toltalNumber: totaldNum,
                selectedNumber: selectedNum,
                isAllChecked: totaldNum === selectedNum ? true : false,
                indeterminate: selectedNum > 0 && selectedNum < totaldNum ? true : false
              }
            }
          }
        }
      } else {
        this._conditionLists = data.map((item) => {
          let totaldNum = item.queryItemlists.length
          let selectedNum = this.countNum(item.queryItemlists)
          return {
            ...item,
            toltalNumber: totaldNum,
            selectedNumber: selectedNum,
            isAllChecked: totaldNum === selectedNum ? true : false,
            indeterminate: selectedNum > 0 && selectedNum < totaldNum ? true : false
          }
        })
      }
 */
      this._conditionListsLength = this._conditionLists.length - 1
    }
  }
  _timeTypeDropdownLists = []
  selectedValue
  @Input() set bcacTimeTypeDropdownLists(data: any) {
    if (data) {
      this.selectedValue = data.defaultValue
      this._timeTypeDropdownLists = data.optLists
    }
  }

  @Input() bcacDatePickerType: string; //single or double
  @Input() bcacQueryDateType: string; //hour day week....
  @Input() bcacDateFormat: string; //日期格式

  @Input() bcacQueryTimeStart: string | Date | number; //小时-天
  @Input() bcacQueryTimeEnd: string | Date | number;     //小时-天


  _bcacQueryTimePickerStart
  @Input() set bcacQueryTimePickerStart(time:  Date) {
    if (time) {
      this._bcacQueryTimePickerStart = new Date(time)
    }
  }
  _bcacQueryTimePickerEnd
  @Input() set bcacQueryTimePickerEnd(time: Date) {
    if (time) {
      this._bcacQueryTimePickerEnd = new Date(time)
    }
  }

  @Input() bcacQueryTime: string | Date | number; //单个时间框
  _bcacQueryTimePicker
  @Input() set bcacQueryTimePicker(time: Date) { //单个时间框time
    if (time) {
      this._bcacQueryTimePicker = new Date(time)
    }
  }


  @Input() set selectedQuater(data: quater) {
    if (data) {
      this._selectedQuater = Number(data)
    }
  }//single季度
  @Input() set selectedQuaterStart(data: quater) {
    if (data) {
      this._selectedQuaterStart = Number(data)
    }
  }//开始季度
  @Input() set selectedQuaterEnd(data: quater) {
    if (data) {
      this._selectedQuaterEnd = Number(data)
    }
  }//结束季度


  countNum(list) {
    let num = 0
    for (const item of list) {
      if (item.checked) {
        num = num + 1
      }
    }
    return num
  }

  //todo 选择改变回调
  @Output() bcacItemChange = new EventEmitter<any>();
  itemChangeCallback(value, e) {
    for (const item of this._conditionLists) {
      if (item.queryItemName === value.queryItemName) {
        let data = item.queryItemlists.map((em) => {
          return {
            ...em,
            checked: e.includes(em.value),
          }
        })
        item.queryItemlists = _.cloneDeep(data)
        let selectNum = this.countNum(item.queryItemlists)
        item.selectedNumber = selectNum
        if (selectNum === item.toltalNumber) {
          item.isAllChecked = true
          item.indeterminate = false
        } else if (selectNum > 0 && selectNum < item.toltalNumber) {
          item.isAllChecked = false
          item.indeterminate = true
        } else {
          item.isAllChecked = false
          item.indeterminate = false
        }
      }
    }
    let par = {
      value: value,
      checkedList: e,
      conditionList: this._conditionLists
    }
    this.bcacItemChange.emit(par)
  }

  //todo 时间下拉改变回调
  @Output() bcacTimeTypeChange = new EventEmitter<any>();
  timeTypeChange(e) {
    switch (e) {
      case 'minute':
        this.bcacQueryDateType = 'minute'
        break
      case 'hour':
        this.bcacQueryDateType = 'hour'
        if (!this._bcacQueryTimePickerStart && !this._bcacQueryTimePickerEnd){
          this._bcacQueryTimePickerStart = new Date(format(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd HH:00:00'))
          this._bcacQueryTimePickerEnd = new Date(format(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd HH:59:59'))
        } else if (!this._bcacQueryTimePicker){
          this._bcacQueryTimePicker = new Date(format(new Date(this.bcacQueryTime), 'yyyy-MM-dd HH:00:00'))
        }
        break
      case 'day':
        this.bcacQueryDateType = 'daynotshowtime'
        break
      case 'week':
        this.bcacQueryDateType = 'week'
        break
      case 'month':
        this.bcacQueryDateType = 'month'
        break
      case 'quater':
        this.bcacQueryDateType = 'quater'
        break
      case 'year':
        this.bcacQueryDateType = 'year'
        break
    }
    this.bcacTimeTypeChange.emit(e)
  }


  @Output() bcacSearch = new EventEmitter<any>();
  //todo 数据查询
  queryByTime() {
    let emitpar = {
      startTime: '',
      endTime: '',
      conditionLists: this._conditionLists,
      dataType: this.bcacQueryDateType
    }
    if (this.bcacDatePickerType == 'double') {
      switch (this.bcacQueryDateType) {
        case 'minute':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'hour':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this._bcacQueryTimePickerStart, 'HH:00:00')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this._bcacQueryTimePickerEnd, 'HH:59:59')
          break;
        case 'dayshowtime':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'daynotshowtime':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd')
          break;
        case 'week':
          emitpar.startTime = this.datepipe.transform(startOfISOWeek(new Date(this.bcacQueryTimeStart)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfISOWeek(new Date(this.bcacQueryTimeEnd)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'month':
          emitpar.startTime = this.datepipe.transform(startOfMonth(new Date(this.bcacQueryTimeStart)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfMonth(new Date(this.bcacQueryTimeEnd)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'quater':
          let years = this.datepipe.transform(this.bcacQueryTimeStart, 'yyyy');
          let yeare = this.datepipe.transform(this.bcacQueryTimeEnd, 'yyyy');
          let dates = new Date(parseInt(years), (3 * this._selectedQuaterStart - 2), 1);
          let datee = new Date(parseInt(yeare), (3 * this._selectedQuaterEnd - 2), 1);
          emitpar.startTime = this.datepipe.transform(startOfQuarter(new Date(dates)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfQuarter(new Date(datee)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'year':
          emitpar.startTime = this.datepipe.transform(startOfYear(new Date(this.bcacQueryTimeStart)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfYear(new Date(this.bcacQueryTimeEnd)), 'yyyy-MM-dd HH:mm:ss')
          break;
      }
    } else {
      switch (this.bcacQueryDateType) {
        case 'hour':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTime), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this._bcacQueryTimePicker, 'HH:00:00')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTime), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this._bcacQueryTimePicker, 'HH:59:59')
          break;
        case 'dayshowtime':
          emitpar.startTime = this.datepipe.transform(startOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'daynotshowtime':
          emitpar.startTime = this.datepipe.transform(startOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd')
          emitpar.endTime = this.datepipe.transform(endOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd')
          break;
        case 'week':
          emitpar.startTime = this.datepipe.transform(startOfISOWeek(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfISOWeek(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'month':
          emitpar.startTime = this.datepipe.transform(startOfMonth(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfMonth(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'quater':
          let year = this.datepipe.transform(this.bcacQueryTime, 'yyyy');
          let date = new Date(parseInt(year), (3 * this._selectedQuater - 2), 1);
          emitpar.startTime = this.datepipe.transform(startOfQuarter(new Date(date)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfQuarter(new Date(date)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'year':
          emitpar.startTime = this.datepipe.transform(startOfYear(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfYear(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
      }
    }
    if (new Date(emitpar.startTime).getTime() > new Date(emitpar.endTime).getTime()) {
      this.message.warning("开始时间不能大于结束时间")
      return
    }
    this.bcacSearch.emit(emitpar);
  }

  //todo 全选按钮
  updateAllChecked(value, e) {
    for (const item of this._conditionLists) {
      if (item.queryItemName === value.queryItemName) {
        item.indeterminate = false
        let data = item.queryItemlists.map((em) => {
          return {
            ...em,
            checked: e,
          }
        })
        item.queryItemlists = _.cloneDeep(data)
        item.selectedNumber = this.countNum(item.queryItemlists)
      }
    }
  }

  ngOnInit() {
  }



  range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };


  //todo nz-time-picker不可选小时
  nzDisabledHours_start = () => []
  nzDisabledHours_end = () => []
  hourStimeChange() {
    let hours = getHours(new Date)//0~23
    let tod = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    if (this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd') == tod) {
      this.nzDisabledHours_start = () => this.range(hours, 24)
    } else {
      this.nzDisabledHours_start = () => []
    }
  }
  hourEtimeChange() {
    let hours = getHours(new Date())//0~23
    let tod = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    if (this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd') == tod) {
      this.nzDisabledHours_end = () => this.range(hours, 24)
    } else {
      this.nzDisabledHours_end = () => []
    }
  }

  today = new Date();  // 今天

  //todo日期选择限制
  disabledDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) > 0;
  }

  //todo 不可选时间 yyyy-MM-dd HH:mm:ss 
  disabledDateTime: DisabledTimeFn = (current: Date) => {
    let curr = this.datepipe.transform(current, 'yyyy-MM-dd')
    let tod = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    let hours = getHours(new Date())//0~23
    let minutes = getMinutes(new Date())//0~59
    let seconds = getSeconds(new Date());//0~59
    if (curr == tod) {
      return {
        nzDisabledHours: () => this.range(hours + 1, 24),
        nzDisabledMinutes: (hour) => {
          if (hour === hours) {
            return this.range(minutes + 1, 60)
          } else { return [] }
        },
        nzDisabledSeconds: (hour: number, minute: number) => {
          if (hour === hours && minute === minutes) {
            return this.range(seconds + 1, 60)
          } else { return [] }
        }
      };
    }
  };

  //todo 时间选择改变回调
  onStartChange($event) {
    if ($event.getTime() > new Date().getTime()) {
      this.bcacQueryTimeStart = new Date()
    }
  }

  //todo 时间选择改变回调
  onEndChange($event) {
    if ($event.getTime() > new Date().getTime()) {
      this.bcacQueryTimeEnd = new Date()
    }
  }
  //todo 开始不可选分钟
  disabledMinuteStart(hour: number): number[] {
    return disabledStart;
  }

  //todo 结束不可选分钟
  disabledMinuteEnd(hour: number): number[] {
    return disabledEnd
  }

  //todo 开始不可选秒
  disabledSecondsStart(hour: number, minute: number): number[] {
    return disabledStart;
  }

  //todo 结束不可选秒
  disabledSecondsEnd(hour: number, minute: number): number[] {
    return disabledEnd
  }


  //todo 格式化周的显示为ISO
  rewriteWeek(e) {
    this.bcacDateFormat = getISOWeekYear(e) + '-' + getISOWeek(e)
    // this.bcacDateFormat = moment(e).isoWeekYear() + '-' + getISOWeek(e)
  }

  //todo 格式化周的显示为ISO
  bcacDateFormatStart
  rewriteWeekStart(e) {
    this.bcacDateFormatStart = getISOWeekYear(e) + '-' + getISOWeek(e)
  }
  //todo 格式化周的显示为ISO
  bcacDateFormatEnd
  rewriteWeekEnd(e) {
    this.bcacDateFormatEnd = getISOWeekYear(e) + '-' + getISOWeek(e)
  }

}
